import "core-js/modules/es.array.push.js";
import request from "../../util/request";
import table2Excel from 'js-table2excel'; // 引入  js-table2excel
import * as XLSX from "xlsx"; // 引入  xlsx
// import Template from "../template/Template";
import { ElLoading } from "element-plus";
// import axios from "axios";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Device',
  // components: {Template},
  data() {
    return {
      /**张 5.13*/
      dialogFormVisibleUnit: false,
      formUnit: {},
      dialogFormVisibleM: false,
      formMaintenancet: {},
      JugeByUnit: 0,
      //使用单位是否重复，0不重复，1重复
      // JugeByUnitE:0,//使用单位是否重复，0不重复，1重复  修改
      JugeByMain: 0,
      //使用单位是否重复，0不重复，1重复
      // JugeByMainE:0,//使用单位是否重复，0不重复，1重复  修改
      rulesAdd: {
        maintenance: [{
          required: true,
          min: 2,
          max: 50,
          validator: this.validateRepeatMain,
          trigger: 'blur'
        }],
        unit: [{
          required: true,
          min: 2,
          max: 50,
          validator: this.validateRepeatUnit,
          trigger: 'blur'
        }],
        createUnit: [{
          required: true,
          message: '请输入制造单位',
          trigger: 'blur'
        }],
        unitCode: [{
          required: true,
          message: '请输入使用单位代码',
          trigger: 'blur'
        }],
        unitArea: [{
          required: true,
          message: '请输入使用单位地址',
          trigger: 'blur'
        }]
      },
      search: '',
      superviseCode: '',
      // isupdate:false,//防止用户多次点击修改确定
      parentId: -1,
      areaList: [],
      areaList2: [],
      areaList3: [],
      areaList4: [],
      areaList5: [],
      areaParentIdOne: '',
      areaParentIdTwo: '',
      areaParentIdThree: '',
      areaParentIdFour: '',
      areaParentIdFive: '',
      form: {},
      editform: {},
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      tableData: [],
      //设备列表
      reload: 0,
      //判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",
      //判断是否已经点击了模糊查询
      varValue1: "",
      //判断是否已经点击了模糊查询
      // saveIs:false,//判断是否已点击添加按钮
      rules: {
        unit: [
        // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
        {
          required: true,
          min: 2,
          max: 50,
          message: '使用单位名不能为空,长度： 2 ~ 50',
          trigger: 'blur'
        }
        // {validator: validateSolution_Name, required: true, message: '方案名重复，重新输入', trigger: 'blur'}
        ],

        specialType: [{
          required: true,
          message: '请输入设备种类',
          trigger: 'blur'
        }],
        // dateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // preDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // createDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // updateDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // superviseDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // majorDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // nextDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // nextTestDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        superviseCode: [{
          required: true,
          message: '请输入监察识别码',
          trigger: 'blur'
        }],
        // unitCode: [{required: true, message: '请输入使用单位代码', trigger: 'blur'}],
        // loginNum: [{required: true, message: '请输入使用登记证编号', trigger: 'blur'}],
        // unitNum: [{required: true, message: '请输入单位内编码', trigger: 'blur'}],
        // liftType: [{required: true, message: '请输入设备品种', trigger: 'blur'}],
        // liftModel: [{required: true, message: '请输入产品型号', trigger: 'blur'}],
        // liftNum: [{required: true, message: '请输入产品编号', trigger: 'blur'}],
        lifeKind: [{
          required: true,
          message: '请选择设备类别',
          trigger: 'blur'
        }],
        // lifeCode: [{required: true, message: '请输入设备代码', trigger: 'blur'}],
        createUnit: [{
          required: true,
          message: '请输入制造单位',
          trigger: 'blur'
        }],
        //   storey: [{required: true, message: '请输入层数', trigger: 'blur'}],
        //   lifeRegistCode: [{required: true, message: '请输入设备注册代码', trigger: 'blur'}],

        // createDate: [{required: true, message: '请输入制造时间', trigger: 'blur'}],
        // createStandard: [{required: true, message: '请输入', trigger: 'blur'}],
        maintenance: [{
          required: true,
          message: '请输入维护保养单位',
          trigger: 'blur'
        }]
        // createStandard2: [{required: true, message: '请输入使用单位地址', trigger: 'blur'}],
        // maxWeight: [{required: true, message: '请输入额定载重量', trigger: 'blur'}],
        // speed: [{required: true, message: '请输入额定速度', trigger: 'blur'}],
        //   storey: [{required: true, message: '请输入层数', trigger: 'blur'}],
        //   stand: [{required: true, message: '请输入站数', trigger: 'blur'}],
        //   door: [{required: true, message: '请输入门数', trigger: 'blur'}],
        // controller: [{required: true, message: '请输入控制方式', trigger: 'blur'}],
      },

      eqptypeList: [],
      //设备类别
      liftTypeList: [],
      //设备品种
      detailArea: '',
      //详细的地址
      count: 0,
      //防止重复提交
      exportConfig: [
      // 导出Excel表格配置
      {
        title: '使用单位名称',
        key: 'unit',
        type: 'text'
      }, {
        title: '使用单位代码',
        key: 'unitCode',
        type: 'text'
      }, {
        title: '使用登记证编号',
        key: 'loginNum',
        type: 'text'
      }, {
        title: '使用设备地点',
        key: 'detailArea',
        type: 'text'
      }, {
        title: '单位内编码',
        key: 'unitNum',
        type: 'text'
      }, {
        title: '设备品种',
        key: 'liftType',
        type: 'text'
      }, {
        title: '产品型号',
        key: 'liftModel',
        type: 'text'
      }, {
        title: '产品编号',
        key: 'liftNum',
        type: 'text'
      }, {
        title: '制造单位',
        key: 'createUnit',
        type: 'text'
      }],
      importLiftkind: ["曳引与强制驱动电梯", "自动扶梯与自动人行道", "消防员电梯", "防爆电梯", "杂物电梯", "斜行乘客与载货电梯", "液压驱动电梯"],
      //导入设备类别用于对比
      importLiftTypeList: ["曳引驱动乘客电梯", "曳引驱动载货电梯", "强制驱动载货电梯", "自动扶梯", "自动人行道", "消防员电梯", "防爆电梯", "杂物电梯", "斜行电梯", "液压乘客电梯", "液压载货电梯"],
      //导入设备品种用于对比
      exportImportConfig: [
      // 导入Excel表格配置
      {
        title: '使用单位名称',
        key: 'unit',
        type: 'text'
      }, {
        title: '使用单位代码',
        key: 'unitCode',
        type: 'text'
      }, {
        title: '使用登记证编号',
        key: 'loginNum',
        type: 'text'
      }, {
        title: '使用设备地点',
        key: 'detailArea',
        type: 'text'
      }, {
        title: '单位内编码',
        key: 'unitNum',
        type: 'text'
      }, {
        title: '设备品种',
        key: 'liftType',
        type: 'text'
      }, {
        title: '产品型号',
        key: 'liftModel',
        type: 'text'
      }, {
        title: '产品编号',
        key: 'liftNum',
        type: 'text'
      }, {
        title: '制造单位',
        key: 'createUnit',
        type: 'text'
      }, {
        title: '制造时间',
        key: 'createDate',
        type: 'text'
      }, {
        title: '轿厢宽度',
        key: 'bridgeBoxWidth',
        type: 'text'
      }, {
        title: '设备种类',
        key: 'specialType',
        type: 'text'
      }, {
        title: '监察识别码',
        key: 'superviseCode',
        type: 'text'
      }, {
        title: '设备类别',
        key: 'lifeKind',
        type: 'text'
      }, {
        title: '维护保养单位',
        key: 'maintenance',
        type: 'text'
      }, {
        title: '区域Id',
        key: 'areaId',
        type: 'text'
      }, {
        title: '区域',
        key: 'areaName',
        type: 'text'
      }, {
        title: '制造执行标准',
        key: 'createStandard',
        type: 'text'
      }, {
        title: '改造单位',
        key: 'updateUnit',
        type: 'text'
      }, {
        title: '改造时间',
        key: 'updateDate',
        type: 'text'
      }, {
        title: '监督检验日期',
        key: 'superviseDate',
        type: 'text'
      }, {
        title: '监督检测类型',
        key: 'superviseType',
        type: 'text'
      }, {
        title: '使用登记机关',
        key: 'organ',
        type: 'text'
      }, {
        title: '紧急救援电话',
        key: 'erpNum',
        type: 'text'
      }, {
        title: '安全管理人员',
        key: 'safety',
        type: 'text'
      }, {
        title: '安全管理人员电话',
        key: 'safetyNum',
        type: 'text'
      }, {
        title: '重大修理单位',
        key: 'majorUnit',
        type: 'text'
      }, {
        title: '施工单位',
        key: 'buildUnit',
        type: 'text'
      }, {
        title: '重大修理时间',
        key: 'majorDate',
        type: 'text'
      }, {
        title: '下次检测时间',
        key: 'nextDate',
        type: 'text'
      }, {
        title: '下次检验时间',
        key: 'nextTestDate',
        type: 'text'
      }, {
        title: '设备代码',
        key: 'lifeCode',
        type: 'text'
      }, {
        title: '设备注册代码',
        key: 'lifeRegistCode',
        type: 'text'
      }, {
        title: '电动机型号',
        key: 'electricModel',
        type: 'text'
      }, {
        title: '桥厢尺寸深度',
        key: 'bridgeBoxDeep',
        type: 'text'
      }, {
        title: '桥厢尺寸高度',
        key: 'bridgeBoxHigth',
        type: 'text'
      }, {
        title: '额定压力',
        key: 'pressure',
        type: 'text'
      }, {
        title: '额定速度',
        key: 'speed',
        type: 'text'
      }, {
        title: '额定速度（上行）',
        key: 'speedUp',
        type: 'text'
      }, {
        title: '额定速度（下行）',
        key: 'speedDown',
        type: 'text'
      }, {
        title: '油缸数量',
        key: 'hcNum',
        type: 'text'
      }, {
        title: '满载压力',
        key: 'maxPressure',
        type: 'text'
      }, {
        title: '上端站',
        key: 'upStation',
        type: 'text'
      }, {
        title: '下端站',
        key: 'downStation',
        type: 'text'
      }, {
        title: '基站',
        key: 'baseStation',
        type: 'text'
      }, {
        title: '悬挂装置规格',
        key: 'hangType',
        type: 'text'
      }, {
        title: '悬挂装置数量',
        key: 'hangNum',
        type: 'text'
      }, {
        title: '防爆等级',
        key: 'flameProof',
        type: 'text'
      }, {
        title: '燃爆物质',
        key: 'material',
        type: 'text'
      }, {
        title: '整机防爆标志',
        key: 'materialSign',
        type: 'text'
      }, {
        title: '受检单位电话',
        key: 'testedNum',
        type: 'text'
      }, {
        title: '缓冲器形式',
        key: 'bufferForm',
        type: 'text'
      }, {
        title: '安全钳类型',
        key: 'safetyGear',
        type: 'text'
      }, {
        title: '拖动方式',
        key: 'drag',
        type: 'text'
      }, {
        title: '制动器形式',
        key: 'brakeForm',
        type: 'text'
      }, {
        title: '悬挂装置',
        key: 'hang',
        type: 'text'
      }, {
        title: '顶升形式',
        key: 'jacking',
        type: 'text'
      }, {
        title: '开门形式',
        key: 'openForm',
        type: 'text'
      }, {
        title: '额定载重量',
        key: 'maxWeight',
        type: 'text'
      }, {
        title: '名义速度',
        key: 'nominalSpeed',
        type: 'text'
      }, {
        title: '名义宽度',
        key: 'nominalWidth',
        type: 'text'
      }, {
        title: '倾斜角',
        key: 'tilt',
        type: 'text'
      }, {
        title: '输送能力',
        key: 'conveying',
        type: 'text'
      }, {
        title: '提升高度',
        key: 'liftingHeight',
        type: 'text'
      }, {
        title: '使用区段长度',
        key: 'section',
        type: 'text'
      }, {
        title: '控制方式',
        key: 'controller',
        type: 'text'
      }, {
        title: '驱动方式',
        key: 'driving',
        type: 'text'
      }, {
        title: '机房形式',
        key: 'computer',
        type: 'text'
      }, {
        title: '驱动主机布置',
        key: 'assign',
        type: 'text'
      }, {
        title: '层',
        key: 'storey',
        type: 'text'
      }, {
        title: '站',
        key: 'stand',
        type: 'text'
      }, {
        title: '门',
        key: 'door',
        type: 'text'
      }, {
        title: '轿门位置',
        key: 'doorPosition',
        type: 'text'
      }, {
        title: '检验类别',
        key: 'testType',
        type: 'text'
      }, {
        title: '设备所在区域',
        key: 'lifeArea',
        type: 'text'
      }, {
        title: '楼盘名称',
        key: 'propertyName',
        type: 'text'
      }, {
        title: '分支机构名称',
        key: 'branchName',
        type: 'text'
      }, {
        title: '驱动主机型号',
        key: 'driveModel',
        type: 'text'
      }, {
        title: '驱动主机编号',
        key: 'driveCode',
        type: 'text'
      }, {
        title: '控制柜型号',
        key: 'controlBoxModel',
        type: 'text'
      }, {
        title: '控制柜编号',
        key: 'controlBoxCode',
        type: 'text'
      }, {
        title: '轿厢限速器型号',
        key: 'carModel',
        type: 'text'
      }, {
        title: '轿厢限速器编号',
        key: 'carCode',
        type: 'text'
      }, {
        title: '对重限速器型号',
        key: 'counterweightModel',
        type: 'text'
      }, {
        title: '对重限速器编号',
        key: 'counterweightModelCode',
        type: 'text'
      }, {
        title: '使用单位地址',
        key: 'unitArea',
        type: 'text'
      }, {
        title: '分支机构地址',
        key: 'branchArea',
        type: 'text'
      }, {
        title: '楼盘地址',
        key: 'propertyArea',
        type: 'text'
      }, {
        title: '监督检验依据',
        key: 'proof',
        type: 'text'
      }, {
        title: '上次检验日期',
        key: 'preDate',
        type: 'text'
      }, {
        title: '上次检验日期格式',
        key: 'preDateType',
        type: 'text'
      }, {
        title: '改造日期格式',
        key: 'updateDateType',
        type: 'text'
      }, {
        title: '下次检测日期格式',
        key: 'nextDateType',
        type: 'text'
      }, {
        title: '制造时间日期格式',
        key: 'createDateType',
        type: 'text'
      }, {
        title: '监督检验日期格式',
        key: 'superviseDateType',
        type: 'text'
      }, {
        title: '重大修理日期格式',
        key: 'majorDateType',
        type: 'text'
      }, {
        title: '下次检验日期格式',
        key: 'nextTestDateType',
        type: 'text'
      }]
    };
  },
  created() {
    this.load();
  },
  /**张 5.13*/
  mounted() {},
  methods: {
    /**张 5.13 使用单位输入框*/
    querySearch(queryString, cb) {
      console.log("开始判断。");
      console.log(queryString);
      if (queryString != "" && queryString.trim().length > 0) {
        request.get('/Unit/getByUnit?unit=' + queryString.trim()).then(res => {
          // var results = queryString ? res.data.filter(this.createFilter(queryString)) : res.data;
          // 调用 callback 返回建议列表的数据
          console.log(res);
          cb(res.data);
        }).catch(error => {
          console.error(error);
          cb([]);
          this.form.propertyArea = "";
          this.form.propertyName = "";
          this.form.safety = "";
          this.form.safetyNum = "";
          this.form.testedNum = "";
          this.form.unitArea = "";
          this.form.unitCode = "";
        });
      }
    },
    /**
     * === 0  是从递一个字开始匹配，也就是模糊查询第一个字
     * > -1   是全字段模糊查询
     * */
    createFilter(queryString) {
      return restaurant => {
        return restaurant.unit.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      };
    },
    handleSelect(item) {
      console.log(item);
      this.form.propertyArea = item.propertyArea;
      this.form.propertyName = item.propertyName;
      this.form.safety = item.safety;
      this.form.safetyNum = item.safetyNum;
      this.form.testedNum = item.testedNum;
      this.form.unitArea = item.unitArea;
      this.form.unitCode = item.unitCode;
    },
    handleSelectM(item) {
      this.form.createUnit = item.createUnit;
      this.form.updateUnit = item.updateUnit;
      this.form.majorUnit = item.majorUnit;
      this.form.buildUnit = item.buildUnit;
      this.form.erpNum = item.erpNum;
      this.form.erpby = item.erpby;
    },
    /**维护保养单位输入框*/
    querySearchM(queryString, cb) {
      if (queryString != "" && queryString.trim().length > 0) {
        request.get('/ProductionInfo/getByMaintenance?maintenance=' + queryString.trim()).then(res => {
          // 调用 callback 返回建议列表的数据
          console.log(res);
          cb(res.data);
        }).catch(error => {
          console.error(error);
          cb([]);
          this.form.createUnit = "";
          this.form.updateUnit = "";
          this.form.majorUnit = "";
          this.form.buildUnit = "";
          this.form.erpNum = "";
          this.form.erpby = "";
        });
      }
    },
    /**打开使用单位添加弹窗 （维保单位添加弹窗）*/
    addUnit(flag) {
      if (flag == 1) {
        this.dialogFormVisibleUnit = true;
        this.formUnit = {};
      } else {
        this.dialogFormVisibleM = true;
        this.formMaintenancet = {};
      }
    },
    /**添加使用单位提交表单*/
    saveUnit(formName) {
      if (!this.validatorUnit()) {
        //验证不通过
        return false;
      }
      console.log(this.$refs[formName]);
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return;
        }
        request.post('/Unit/save', this.formUnit).then(res => {
          this.count = 0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0") {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.load(1);
            this.dialogFormVisibleUnit = false;
          } else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**添加使用单位提交表单*/
    saveMaintance(formName) {
      if (!this.validatorMain()) {
        //验证不通过
        return false;
      }
      console.log(this.$refs[formName]);
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return;
        }
        request.post('/ProductionInfo/save', this.formMaintenancet).then(res => {
          this.count = 0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0") {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.load(1);
            this.dialogFormVisibleM = false;
          } else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //验证使用单位名称是否重复
    validateRepeatUnit(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择或添加'));
      } else {
        request.get('/Unit/JugeByUnit?unit=' + value.trim()).then(res => {
          const data = res.data.flag;
          this.JugeByUnit = res.data.flag;
          if (data === 0) {
            callback();
          } else {
            callback(new Error('该维保单位名称已存在'));
          }
        });
      }
    },
    //表单验证 使用单位添加
    validatorUnit() {
      if (this.dialogFormVisibleUnit) {
        //添加
        if (this.formUnit.unit === '' || this.formUnit.unit === null || this.formUnit.unit === undefined) {
          this.$message({
            message: "请填写使用单位名称",
            type: "warning"
          });
          return false;
        }
        if (this.JugeByUnit === 1) {
          this.$message({
            message: "使用单位名称重复",
            type: "warning"
          });
          return false;
        }
        if (this.formUnit.unitArea === '' || this.formUnit.unitArea === null || this.formUnit.unitArea === undefined) {
          this.$message({
            message: "请填写使用单位地址",
            type: "warning"
          });
          return false;
        }
        if (this.formUnit.unitCode === '' || this.formUnit.unitCode === null || this.formUnit.unitCode === undefined) {
          this.$message({
            message: "请填写使用单位代码",
            type: "warning"
          });
          return false;
        }
      }
      return true;
    },
    //维保单位验证是否重复
    validateRepeatMain(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择或添加'));
      } else {
        request.get('/ProductionInfo/JugeMaintenance?maintenance=' + value.trim()).then(res => {
          const data = res.data.flag;
          this.JugeByMain = res.data.flag;
          if (data === 0) {
            callback();
          } else {
            callback(new Error('该维保单位名称已存在'));
          }
        });
      }
    },
    //维保单位表单验证
    validatorMain() {
      if (this.dialogFormVisibleM) {
        //添加
        if (this.formMaintenancet.maintenance === '' || this.formMaintenancet.maintenance === null || this.formMaintenancet.maintenance === undefined) {
          this.$message({
            message: "请填写维保单位名称",
            type: "warning"
          });
          return false;
        }
        if (this.JugeByMain === 1) {
          this.$message({
            message: "维保单位名称重复",
            type: "warning"
          });
          return false;
        }
        // if (this.formMaintenancet.createUnit === '' || this.formMaintenancet.createUnit === null || this.formMaintenancet.createUnit === undefined) {
        //   this.$message({
        //     message: "请填写制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }
      }

      return true;
    },
    //导出数据
    exportDate() {
      const loading = ElLoading.service({
        // 打开遮罩层
        lock: true,
        text: '请稍等...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "sign": '1' //用于判断是否查询所有
      };

      request.post('/Device/deviceAll', map).then(res => {
        console.log(res);
        if (res.code === "0") {
          let table = res.data.deviceList;
          let arr = JSON.parse(JSON.stringify(table));
          // let arr =JSON.parse(JSON.stringify(this.tableData)) ;
          console.log(arr);
          let date = this.formatDate(new Date(), "yyyy-MM-dd");
          table2Excel(this.exportConfig, arr, '设备导出数据_' + date);
          // table2Excel(this.exportImportConfig, arr, '设备导出数据_'+date)
          loading.close(); // 关闭遮罩层
        } else {
          this.$message({
            message: "导出数据失败",
            type: "error"
          });
          loading.close(); // 关闭遮罩层
        }
      });
    },

    // 表格导入
    importBefore(file) {
      const reader = new FileReader();
      reader.onload = e => {
        const data = e.target.result;
        // console.log(data)
        const workbook = XLSX.read(data, {
          type: "array"
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const results = XLSX.utils.sheet_to_json(worksheet);
        // this.importAdd(results)
        this.getArea(results);
      };
      reader.readAsArrayBuffer(file);
    },
    importAdd(list, areas, vDeviceArea, loading) {
      let areasError = []; //区域报错的行
      let maintenanceError = []; //维护保养单位报错的行
      let unitError = []; //使用单位报错的行
      let superviseCodeError = []; //监察识别码报错的行
      let lifeKindError = []; //设备类别报错的行
      let detailAreaError = []; //详细地址报错的行
      // 处理上传时excel中特殊字段
      // 如：性别：男/女 不能以文字形式上传，此方法时将数据转为对应的值
      list.forEach((item, index) => {
        // this.exportConfig.forEach((i) => {
        this.exportImportConfig.forEach(i => {
          // console.log(item[i.title]+"-.trim()--"+i.title.length)
          // if(item[i.title]!=null && item[i.title]!==""&& item[i.title]!=undefined&& item[i.title]!="null"){
          item[i.key] = item[i.title];
          delete item[i.title];
          // }
        });
        // 处理时间，在使用FileReader解析后的时间可能是这样的 44877.4284259259 就需要专为时间戳或者时间格式
        for (let key in item) {
          areas.forEach(obj => {
            if (item["areaName"] == "" || item["areaName"] === undefined || item["areaName"] == "null") {
              if (!areasError.includes(index + 1)) {
                areasError.push(index + 1);
              }
            } else {
              //根据所在区域选择对应的区域Id
              if (obj.areaName === item["areaName"].trim()) {
                item["areaId"] = obj.areaId;
                // console.log("==== item[\"areaId\"]=="+ item["areaId"])
              }
            }
          });
          //默认为电梯类型
          if (key == "specialType") {
            item[key] = 1;
          }
          if (key == "unit") {
            if (item[key] == " " || item[key] == "" || item[key] === undefined || item[key] == "null") {
              console.log("---------unit-------" + item[key]);
              if (!unitError.includes(index + 1)) {
                unitError.push(index + 1);
                // console.log("---------unit--11-----")
              }
            }
          }

          if (key == "superviseCode") {
            if (item[key] == " " || item[key] == "" || item[key] === undefined || item[key] == "null") {
              if (!superviseCodeError.includes(index + 1)) {
                superviseCodeError.push(index + 1);
              }
            }
          }
          if (key == "lifeKind") {
            if (item[key] == " " || item[key] == "" || item[key] === undefined || item[key] == "null") {
              if (!lifeKindError.includes(index + 1)) {
                lifeKindError.push(index + 1);
              }
            }
          }
          if (key == "detailArea") {
            if (item[key] == " " || item[key] == "" || item[key] === undefined || item[key] == "null") {
              if (!detailAreaError.includes(index + 1)) {
                detailAreaError.push(index + 1);
              }
            }
          }
          if (key == "maintenance") {
            if (item[key] == " " || item[key] == "" || item[key] === undefined || item[key] == "null") {
              if (!maintenanceError.includes(index + 1)) {
                maintenanceError.push(index + 1);
              }
            }
          }
          //处理时间格式
          if (key == "createDate" || key == "updateDate" || key == "superviseDate" || key == "majorDate" || key == "nextDate" || key == "nextTestDate" || key == "preDate") {
            if (item[key] !== "" && item[key] !== undefined && item[key] !== "null") {
              item[key] = this.ExcelDateToJSDate(item[key]);
              item[key] = this.formatDate(item[key], "yyyy-MM-dd");
              if (item[key] === "NaN-aN-aN") {
                this.$message({
                  message: "时间格式出错，出错行有：" + (index + 1),
                  type: "error"
                });
                loading.close(); // 关闭遮罩层
                return;
              }
              // if(item[key].length>7) {
              //   item[key] = item[key].substring(0, 10);
              // }else if(item[key].length>5) {
              //   item[key] = item[key].substring(0, 8)+"-10";
              // }else if(item[key].length>3) {
              //   item[key] = item[key].substring(0, 5)+"-10-10";
              // }
            }
          }

          if (item[key] === undefined || item[key] === "null") {
            item[key] = ""; //防止不填信息报错
          }

          if (item[key] != null && item[key] !== "" && item[key] != undefined && item[key] != "null") {
            item[key] = item[key].toString().trim(); //去除前后空格
          }
        }
      });

      if (areasError != null && areasError.length > 0) {
        this.$message({
          message: "区域名称出错，区域名称不能为空(或区域名称标题存在空格)，出错行有：" + areasError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      if (unitError != null && unitError.length > 0) {
        this.$message({
          message: "使用单位出错,使用单位不能为空(或使用单位标题存在空格)，出错行有：" + unitError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      if (superviseCodeError != null && superviseCodeError.length > 0) {
        this.$message({
          message: "监察识别码出错，监察识别码不能为空(或监察识别码标题存在空格)，出错行有：" + superviseCodeError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      if (lifeKindError != null && lifeKindError.length > 0) {
        this.$message({
          message: "设备类别出错，设备类别不能为空(或设备类别标题存在空格)，出错行有：" + lifeKindError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      if (detailAreaError != null && detailAreaError.length > 0) {
        this.$message({
          message: "详细地址出错，详细地址不能为空(或详细地址标题存在空格)，出错行有：" + detailAreaError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      if (maintenanceError != null && maintenanceError.length > 0) {
        this.$message({
          message: "维护保养单位出错，维护保养单位不能为空(或维护保养单位标题存在空格)，出错行有：" + maintenanceError,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      let liftkinds = [];
      let liftkindlist = list.filter((e, i) => {
        if (e.lifeKind != null && e.lifeKind !== "" && e.lifeKind != undefined && e.lifeKind != "null") {
          if (!this.importLiftkind.includes(e.lifeKind.trim())) {
            liftkinds.push(i + 1);
          }
          return !this.importLiftkind.includes(e.lifeKind.trim());
        }
      });
      if (liftkindlist != null && liftkindlist.length > 0) {
        this.$message({
          message: "设备类别出错，设备类别未识别(或设备类别标题存在空格)，出错行有：" + liftkinds,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      let liftTypes = [];
      let liftTypelist = list.filter((e, i) => {
        if (e.liftType != null && e.liftType !== "" && e.liftType != undefined && e.liftType != "null") {
          if (!this.importLiftTypeList.includes(e.liftType.trim())) {
            liftTypes.push(i + 1);
          }
          return !this.importLiftTypeList.includes(e.liftType.trim());
        }
      });
      if (liftTypelist != null && liftTypelist.length > 0) {
        this.$message({
          message: "设备种类出错，设备种类未识别(或设备种类标题存在空格)，出错行有：" + liftTypes,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      let ids = areas.map(e => e.areaName);
      let index = [];
      let orders = list.filter((e, i) => {
        if (e.areaName != null && e.areaName !== "" && e.areaName != undefined && e.areaName != "null") {
          if (!ids.includes(e.areaName.trim())) {
            index.push(i + 1);
          }
          return !ids.includes(e.areaName.trim());
        }
      });
      //对比区域名称是否未添加
      if (orders != null && orders.length > 0) {
        this.$message({
          message: "区域名称出错，区域未添加，出错行有：" + index,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      //对比监察识别码是否重复
      let superviseCodes = vDeviceArea.map(e => e.superviseCode);
      let a = [];
      let lists = list.filter((e, i) => {
        if (superviseCodes.includes(e.superviseCode.trim())) {
          a.push(i + 1);
        }
        return superviseCodes.includes(e.superviseCode.trim());
      });
      if (lists != null && lists.length > 0) {
        this.$message({
          message: "监察识别码重复了，出错行有：" + a,
          type: "error"
        });
        loading.close(); // 关闭遮罩层
        return;
      }
      list = this.convertImportData(list);
      // list 返回上传的Excel文件，接下来掉后台接口批量添加就可以了。
      console.log(list);
      // loading.close() // 关闭遮罩层
      request.post('/Device/importDeviceAll', list).then(res => {
        console.log(res);
        if (res.code === "0") {
          this.$message({
            message: "导入数据成功",
            type: "success"
          });
          loading.close(); // 关闭遮罩层
          this.load();
        } else {
          this.$message({
            message: "导入数据失败",
            type: "error"
          });
          loading.close(); // 关闭遮罩层
        }
      });
    },

    getDate(strDate) {
      var date = eval('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/, function (a) {
        return parseInt(a, 10) - 1;
      }).match(/\d+/g) + ')');
      return date;
    },
    getArea(list) {
      const loading = ElLoading.service({
        // 打开遮罩层
        lock: true,
        text: '请稍等...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "sign": '1' //用于判断是否查询所有
      };

      request.post('/Device/getArea', map).then(res => {
        if (res.code === "0") {
          // console.log( res.data);
          this.importAdd(list, res.data.areas, res.data.vDeviceArea, loading);
        } else {
          this.$message({
            message: "查询区域失败",
            type: "error"
          });
          loading.close(); // 关闭遮罩层
        }
      });
    },

    //查询区域信息和设备信息
    convertImportData(list) {
      list.forEach(item => {
        // this.formatColumns.forEach((i) => {
        //   for (let key in i.option) {
        //     if (item[i.prop] == i.option[key]) {
        //       item[i.prop] = key
        //     }
        //   }
        // })
        for (let key in item) {
          if (!item[key] && item[key] == undefined) {
            item[key] = "";
          }
        }
      });
      return list;
    },
    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    },
    refresh() {
      //刷新
      this.search = '';
      this.superviseCode = '';
      this.load(0);
    },
    qSearch() {
      this.load(0);
      this.varValue = this.search;
      this.varValue1 = this.superviseCode;
    },
    closeDialog(tag, formName) {
      if (tag === 0) {
        this.dialogFormVisible = false;
        this.form = {};
        this.$refs[formName].resetFields();
      } else if (tag === 1) {
        this.dialogFormVisibleEdit = false;
        this.editform = {};
        this.$refs[formName].resetFields();
      } else if (tag === 2) {
        this.dialogFormVisibleUnit = false;
        this.formUnit = {};
        this.$refs[formName].resetFields();
      } else {
        this.dialogFormVisibleM = false;
        this.formMaintenancet = {};
        this.$refs[formName].resetFields();
      }
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
      this.form = {};
      this.areaParentIdOne = "";
      this.queryAreaList(this.parentId);
      // this.getEqpType();
    },

    getDateType() {//选择日期格式
    },
    // dateType(dateType, date) {//
    //   if (dateType === '年月日') {
    //     date = this.formatDate(date, "yyyy年MM月dd日")
    //   } else if (dateType === '年月') {
    //     date = this.formatDate(date, "yyyy年MM月")
    //   } else {
    //     date = this.formatDate(date, "yyyy年")
    //   }
    //   return date;
    // },
    // dateShow(dateType,date){
    //   if (dateType === '年月日') {
    //     date = this.formatDate(date, "yyyy-MM-dd")
    //   } else if (dateType === '年月') {
    //     date = this.formatDate(date, "yyyy-MM")
    //   } else {
    //     date = this.formatDate(date, "yyyy")
    //   }
    //   return date;
    // },
    getEqpType(EqpType, id) {
      //查询设备类别
      console.log(EqpType, id);
      this.eqptypeList = [];
      this.form.liftType = '';
      this.form.lifeKind = '';
      request.post('/Device/getEqpType', EqpType).then(res => {
        console.log(res.code + res.mag + res.data + "getEqpType" + res);
        if (res.code === "0") {
          this.eqptypeList = res.data;
          // if(id===1){//修改
          //     this.
          // }
        } else {
          this.$message({
            message: "查询设备类别失败",
            type: "error"
          });
        }
      });
    },
    getliftType(lifeKind, id) {
      //查询设备品种
      console.log(lifeKind);
      this.liftTypeList = [];
      request.get('/Device/getliftType?lifeKind=' + lifeKind).then(res => {
        console.log(res.code + res.mag + res.data + "getliftType" + res);
        if (res.code === "0") {
          this.liftTypeList = res.data;
          if (id === 0) {
            this.form.liftType = '';
          } else {
            for (let i = 0; i < this.liftTypeList.length; i++) {
              if (this.liftTypeList.find(e => e.liftType === this.editform.liftType)) {
                // console.log("222")
              } else this.editform.liftType = '';
            }
          }
        } else {
          this.$message({
            message: "查询设备品种失败",
            type: "error"
          });
          this.editform.liftType = '';
          this.form.liftType = '';
        }
      });
    },
    //时间格式
    formatDate(value, fmt) {
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load(reload) {
      if ((this.search !== '' || this.superviseCode !== '') && this.currentPage !== 1) {
        if (this.reload === reload) {
          this.currentPage = 1;
        }
      }
      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "superviseCode": this.superviseCode
        // "sign":sign//用于判断是否查询所有
      };

      request.post('/Device/deviceAll', map).then(res => {
        console.log(res);
        if (res.code === "0") {
          this.tableData = res.data.deviceList;
          this.total = res.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    validator() {
      //表单验证
      if (this.dialogFormVisibleEdit) {
        //修改
        if (this.editform.specialType === '' || this.editform.specialType === null || this.editform.specialType === undefined) {
          this.$message({
            message: "请选择设备种类",
            type: "warning"
          });
          return false;
        }
        if (this.editform.detailArea === '' || this.editform.detailArea === null || this.editform.detailArea === undefined) {
          this.$message({
            message: "请选择具体地址",
            type: "warning"
          });
          return false;
        } else this.editform.detailArea = this.editform.detailArea.toString().trim();
        // if (this.editform.lifeRegistCode === ''||this.editform.lifeRegistCode === null || this.editform.lifeRegistCode === undefined) {
        //     this.$message({
        //         message: "请输入设备注册代码",
        //         type: "warning"
        //     });
        //     return false;
        // }
        if (this.editform.unit === '' || this.editform.unit === null || this.editform.unit === undefined) {
          this.$message({
            message: "请输入使用单位名称",
            type: "warning"
          });
          return false;
        } else this.editform.unit = this.editform.unit.toString().trim();
        // if (this.editform.unitCode === '' || this.editform.unitCode === null || this.editform.unitCode === undefined) {
        //   this.$message({
        //     message: "请输入使用单位代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.loginNum === '' || this.editform.loginNum === null || this.editform.loginNum === undefined) {
        //   this.$message({
        //     message: "请输入使用登记证编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.unitNum === '' || this.editform.unitNum === null || this.editform.unitNum === undefined) {
        //   this.$message({
        //     message: "请输入单位内编码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.lifeCode === '' || this.editform.lifeCode === null || this.editform.lifeCode === undefined) {
        //   this.$message({
        //     message: "请输入设备代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.editform.lifeKind === '' || this.editform.lifeKind === null || this.editform.lifeKind === undefined) {
          this.$message({
            message: "请输入设备类别",
            type: "warning"
          });
          return false;
        } else this.editform.lifeKind = this.editform.lifeKind.toString().trim();
        // if (this.editform.liftType === '' || this.editform.liftType === null || this.editform.liftType === undefined) {
        //   this.$message({
        //     message: "请输入设备品种",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.liftModel === '' || this.editform.liftModel === null || this.editform.liftModel === undefined) {
        //   this.$message({
        //     message: "请输入产品型号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.liftNum === '' || this.editform.liftNum === null || this.editform.liftNum === undefined) {
        //   this.$message({
        //     message: "请输入产品编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.createUnit === '' || this.editform.createUnit === null || this.editform.createUnit === undefined) {
        //   this.$message({
        //     message: "请输入制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }

        if (this.editform.specialType === 1) {
          //选择电梯
          if (this.editform.superviseCode === '' || this.editform.superviseCode === null || this.editform.superviseCode === undefined) {
            this.$message({
              message: "请输入监察识别码",
              type: "warning"
            });
            return false;
          } else {
            this.editform.superviseCode = this.editform.superviseCode.toString().trim();
          }
          // if (this.editform.storey === ''||this.editform.storey === null || this.editform.storey === undefined) {
          //     this.$message({
          //         message: "请输入层数",
          //         type: "warning"
          //     });
          //     return false;
          // }
          // if (this.editform.createDate === '' || this.editform.createDate === null || this.editform.createDate === undefined) {
          //   this.$message({
          //     message: "请输入制造时间",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.editform.createStandard === '' || this.editform.createStandard === null || this.editform.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入制造执行标准",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
            this.$message({
              message: "请输入维护保养单位",
              type: "warning"
            });
            return false;
          } else this.editform.maintenance = this.editform.maintenance.toString().trim();
        } else {
          //起重机的修改
          // if (this.editform.createStandard === '' || this.editform.createStandard === null || this.editform.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入使用单位地址",
          //     type: "warning"
          //   });
          //   return false;
          // }

          // if (this.editform.createDate === '' || this.editform.createDate === null || this.editform.createDate === undefined) {
          //   this.$message({
          //     message: "请输入投入使用日期",
          //     type: "warning"
          //   });
          //   return false;
          // }

          if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
            this.$message({
              message: "请输入使用单位邮政编码",
              type: "warning"
            });
            return false;
          } else this.editform.maintenance = this.editform.maintenance.toString().trim();
        }
      }
      if (this.dialogFormVisible) {
        //添加
        if (this.form.specialType === '' || this.form.specialType === null || this.form.specialType === undefined) {
          this.$message({
            message: "请选择设备种类",
            type: "warning"
          });
          return false;
        }
        // if (this.form.lifeRegistCode === ''||this.form.lifeRegistCode === null || this.form.lifeRegistCode === undefined) {
        //     this.$message({
        //         message: "请输入设备注册代码",
        //         type: "warning"
        //     });
        //     return false;
        // }

        if (this.form.unit === '' || this.form.unit === null || this.form.unit === undefined) {
          this.$message({
            message: "请输入使用单位名称",
            type: "warning"
          });
          return false;
        } else this.form.unit = this.form.unit.toString().trim();
        // if (this.form.unitCode === '' || this.form.unitCode === null || this.form.unitCode === undefined) {
        //   this.$message({
        //     message: "请输入使用单位代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.loginNum === '' || this.form.loginNum === null || this.form.loginNum === undefined) {
        //   this.$message({
        //     message: "请输入使用登记证编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.unitNum === '' || this.form.unitNum === null || this.form.unitNum === undefined) {
        //   this.$message({
        //     message: "请输入单位内编码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.lifeCode === '' || this.form.lifeCode === null || this.form.lifeCode === undefined) {
        //   this.$message({
        //     message: "请输入设备代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.form.lifeKind === '' || this.form.lifeKind === null || this.form.lifeKind === undefined) {
          this.$message({
            message: "请输入设备类别",
            type: "warning"
          });
          return false;
        } else this.form.lifeKind = this.form.lifeKind.toString().trim();
        if (this.form.detailArea === '' || this.form.detailArea === null || this.form.detailArea === undefined) {
          this.$message({
            message: "请选择具体地址",
            type: "warning"
          });
          return false;
        } else this.form.detailArea = this.form.detailArea.toString().trim();
        // if (this.form.liftType === '' || this.form.liftType === null || this.form.liftType === undefined) {
        //   this.$message({
        //     message: "请输入设备品种",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.liftModel === '' || this.form.liftModel === null || this.form.liftModel === undefined) {
        //   this.$message({
        //     message: "请输入产品型号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.liftNum === '' || this.form.liftNum === null || this.form.liftNum === undefined) {
        //   this.$message({
        //     message: "请输入产品编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.createUnit === '' || this.form.createUnit === null || this.form.createUnit === undefined) {
        //   this.$message({
        //     message: "请输入制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.form.specialType === 1) {
          //选择了电梯
          if (this.form.superviseCode === '' || this.form.superviseCode === null || this.form.superviseCode === undefined) {
            this.$message({
              message: "请输入监察识别码",
              type: "warning"
            });
            return false;
          } else {
            this.form.superviseCode = this.form.superviseCode.toString().trim();
          }
          // if (this.form.storey === ''||this.form.storey === null || this.form.storey === undefined) {
          //     this.$message({
          //         message: "请输入层数",
          //         type: "warning"
          //     });
          //     return false;
          // }
          // if (this.form.createDate === '' || this.form.createDate === null || this.form.createDate === undefined) {
          //   this.$message({
          //     message: "请输入制造时间",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.form.createStandard === '' || this.form.createStandard === null || this.form.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入制造执行标准",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.form.maintenance === '' || this.form.maintenance === null || this.form.maintenance === undefined) {
            this.$message({
              message: "请输入维护保养单位",
              type: "warning"
            });
            return false;
          } else this.form.maintenance = this.form.maintenance.toString().trim();
        } else {
          //选择了起重机
          // console.log("1111------")
          // if (this.form.createStandard === '' || this.form.createStandard === null || this.form.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入使用单位地址",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.form.createDate === '' || this.form.createDate === null || this.form.createDate === undefined) {
          //   this.$message({
          //     message: "请输入投入使用日期",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.form.maintenance === '' || this.form.maintenance === null || this.form.maintenance === undefined) {
            this.$message({
              message: "请输入使用单位邮政编码",
              type: "warning"
            });
            return false;
          } else this.form.maintenance = this.form.maintenance.toString().trim();
        }
      }
      // if (this.areaParentIdFive === '' || this.areaParentIdFive === null || this.areaParentIdFive === undefined) {
      //   this.$message({
      //     message: "请选择具体地址",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if (this.areaParentIdThree === '' || this.areaParentIdThree === null || this.areaParentIdThree === undefined) {
        this.$message({
          message: "请选择区或镇",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    //保持数据
    save(formName) {
      // this.validator();
      if (!this.validator()) {
        //验证不通过
        return false;
      }
      console.log(this.$refs[formName]);
      // this.$refs[formName].validate((valid) => {
      //valid是检验的结果,bool值 validator: validateSolution_Name,
      // if (valid) {
      //     this.saveIs =true;
      // this.form.areaId = this.areaList5[this.areaParentIdFive].areaId;
      this.form.areaId = this.areaList3[this.areaParentIdThree].areaId;
      let device = null;
      if (this.form.specialType === 1) {
        device = {
          // liftId :this.form.liftId,
          areaId: this.form.areaId,
          unit: this.form.unit,
          // dateType: this.form.dateType,
          unitCode: this.form.unitCode,
          loginNum: this.form.loginNum,
          unitNum: this.form.unitNum,
          liftType: this.form.liftType,
          liftModel: this.form.liftModel,
          liftNum: this.form.liftNum,
          createUnit: this.form.createUnit,
          createDate: this.form.createDate,
          createStandard: this.form.createStandard,
          updateUnit: this.form.updateUnit,
          updateDate: this.form.updateDate,
          maintenance: this.form.maintenance,
          superviseDate: this.form.superviseDate,
          superviseType: this.form.superviseType,
          organ: this.form.organ,
          erpNum: this.form.erpNum,
          safety: this.form.safety,
          safetyNum: this.form.safetyNum,
          majorUnit: this.form.majorUnit,
          buildUnit: this.form.buildUnit,
          majorDate: this.form.majorDate,
          nextDate: this.form.nextDate,
          nextTestDate: this.form.nextTestDate,
          lifeCode: this.form.lifeCode,
          lifeRegistCode: this.form.lifeRegistCode,
          lifeKind: this.form.lifeKind,
          electricModel: this.form.electricModel,
          bridgeBoxWidth: this.form.bridgeBoxWidth,
          bridgeBoxDeep: this.form.bridgeBoxDeep,
          bridgeBoxHigth: this.form.bridgeBoxHigth,
          pressure: this.form.pressure,
          speed: this.form.speed,
          speedUp: this.form.speedUp,
          speedDown: this.form.speedDown,
          hcNum: this.form.hcNum,
          maxPressure: this.form.maxPressure,
          upStation: this.form.upStation,
          downStation: this.form.downStation,
          baseStation: this.form.baseStation,
          hangType: this.form.hangType,
          hangNum: this.form.hangNum,
          flameProof: this.form.flameProof,
          material: this.form.material,
          materialSign: this.form.materialSign,
          testedNum: this.form.testedNum,
          bufferForm: this.form.bufferForm,
          safetyGear: this.form.safetyGear,
          drag: this.form.drag,
          brakeForm: this.form.brakeForm,
          hang: this.form.hang,
          jacking: this.form.jacking,
          openForm: this.form.openForm,
          maxWeight: this.form.maxWeight,
          nominalSpeed: this.form.nominalSpeed,
          nominalWidth: this.form.nominalWidth,
          tilt: this.form.tilt,
          conveying: this.form.conveying,
          liftingHeight: this.form.liftingHeight,
          section: this.form.section,
          controller: this.form.controller,
          driving: this.form.driving,
          computer: this.form.computer,
          assign: this.form.assign,
          storey: this.form.storey,
          stand: this.form.stand,
          door: this.form.door,
          doorPosition: this.form.doorPosition,
          testType: '',
          specialType: this.form.specialType,
          superviseCode: this.form.superviseCode,
          lifeArea: this.form.lifeArea,
          propertyName: this.form.propertyName,
          branchName: this.form.branchName,
          driveModel: this.form.driveModel,
          driveCode: this.form.driveCode,
          controlBoxModel: this.form.controlBoxModel,
          controlBoxCode: this.form.controlBoxCode,
          carModel: this.form.carModel,
          carCode: this.form.carCode,
          counterweightModel: this.form.counterweightModel,
          counterweightModelCode: this.form.counterweightModelCode,
          unitArea: this.form.unitArea,
          branchArea: this.form.branchArea,
          propertyArea: this.form.propertyArea,
          proof: this.form.proof,
          preDate: this.form.preDate,
          preDateType: this.form.preDateType,
          updateDateType: this.form.updateDateType,
          nextDateType: this.form.nextDateType,
          createDateType: this.form.createDateType,
          superviseDateType: this.form.superviseDateType,
          majorDateType: this.form.majorDateType,
          nextTestDateType: this.form.nextTestDateType,
          detailArea: this.form.detailArea
        };
      } else {
        device = {
          // liftId :this.form.liftId,
          areaId: this.form.areaId,
          // dateType: this.form.dateType,
          unit: this.form.unit,
          unitCode: this.form.unitCode,
          loginNum: this.form.loginNum,
          unitNum: this.form.unitNum,
          liftType: this.form.liftType,
          liftModel: this.form.liftModel,
          liftNum: this.form.liftNum,
          createUnit: this.form.createUnit,
          createDate: this.form.createDate,
          createStandard: this.form.createStandard,
          updateUnit: this.form.updateUnit,
          updateDate: this.form.updateDate,
          maintenance: this.form.maintenance,
          superviseDate: this.form.superviseDate,
          superviseType: this.form.superviseType,
          organ: this.form.organ,
          erpNum: this.form.erpNum,
          safety: this.form.safety,
          safetyNum: this.form.safetyNum,
          majorUnit: this.form.majorUnit,
          buildUnit: this.form.buildUnit,
          majorDate: this.form.majorDate,
          nextDate: this.form.nextDate,
          nextTestDate: this.form.nextTestDate,
          lifeCode: this.form.lifeCode,
          lifeRegistCode: this.form.lifeRegistCode,
          lifeKind: this.form.lifeKind,
          electricModel: this.form.electricModel,
          bridgeBoxWidth: this.form.bridgeBoxWidth,
          bridgeBoxDeep: this.form.bridgeBoxDeep,
          bridgeBoxHigth: this.form.bridgeBoxHigth,
          pressure: this.form.pressure,
          speed: this.form.speed,
          speedUp: this.form.speedUp,
          speedDown: this.form.speedDown,
          hcNum: this.form.hcNum,
          maxPressure: this.form.maxPressure,
          upStation: this.form.upStation,
          downStation: this.form.downStation,
          baseStation: this.form.baseStation,
          hangType: this.form.hangType,
          hangNum: this.form.hangNum,
          flameProof: this.form.flameProof,
          material: this.form.material,
          materialSign: this.form.materialSign,
          testedNum: this.form.testedNum,
          bufferForm: this.form.bufferForm,
          safetyGear: this.form.safetyGear,
          drag: this.form.drag,
          brakeForm: this.form.brakeForm,
          hang: this.form.hang,
          jacking: this.form.jacking,
          openForm: this.form.openForm,
          maxWeight: this.form.maxWeight,
          nominalSpeed: this.form.nominalSpeed,
          nominalWidth: this.form.nominalWidth,
          tilt: this.form.tilt,
          conveying: this.form.conveying,
          liftingHeight: this.form.liftingHeight,
          section: this.form.section,
          controller: this.form.controller,
          driving: this.form.driving,
          computer: this.form.computer,
          assign: this.form.assign,
          storey: 0,
          stand: 0,
          door: 0,
          doorPosition: this.form.doorPosition,
          testType: this.form.testType,
          specialType: this.form.specialType,
          superviseCode: this.form.superviseCode,
          lifeArea: this.form.lifeArea,
          propertyName: this.form.propertyName,
          branchName: this.form.branchName,
          driveModel: this.form.driveModel,
          driveCode: this.form.driveCode,
          controlBoxModel: this.form.controlBoxModel,
          controlBoxCode: this.form.controlBoxCode,
          carModel: this.form.carModel,
          carCode: this.form.carCode,
          counterweightModel: this.form.counterweightModel,
          counterweightModelCode: this.form.counterweightModelCode,
          unitArea: this.form.unitArea,
          branchArea: this.form.branchArea,
          propertyArea: this.form.propertyArea,
          proof: this.form.proof,
          preDate: this.form.preDate,
          preDateType: this.form.preDateType,
          updateDateType: this.form.updateDateType,
          nextDateType: this.form.nextDateType,
          createDateType: this.form.createDateType,
          superviseDateType: this.form.superviseDateType,
          majorDateType: this.form.majorDateType,
          nextTestDateType: this.form.nextTestDateType,
          detailArea: this.form.detailArea
        };
      }
      // console.log(new Date().getTime()+"-------1")
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          // console.log(new Date().getTime()+"-------2")
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return;
        }
        // console.log(new Date().getTime()+"-------3")
        request.post('/Device/save', device).then(res => {
          // console.log(new Date().getTime()+"-------4")

          this.count = 0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0" && res.data === 1) {
            this.$message({
              message: "监察识别码已存在",
              type: "success"
            });
            // this.saveIs =false;
            this.load(1);
            this.dialogFormVisible = false;
          } else if (res.code === "0" && res.data === 0) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.saveIs =false;
            this.load(1);
            this.dialogFormVisible = false;
          } else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //修改数据
    edit(formName) {
      // this.validator();
      if (!this.validator()) {
        //验证不通过
        return false;
      }
      // this.isupdate =true;
      console.log(formName);
      // this.editform.areaId = this.areaList5[this.areaParentIdFive].areaId;
      this.editform.areaId = this.areaList3[this.areaParentIdThree].areaId;
      let device = null;
      if (this.editform.specialType === 1) {
        device = {
          liftId: this.editform.liftId,
          areaId: this.editform.areaId,
          // dateType: this.editform.dateType,
          unit: this.editform.unit,
          unitCode: this.editform.unitCode,
          loginNum: this.editform.loginNum,
          unitNum: this.editform.unitNum,
          liftType: this.editform.liftType,
          liftModel: this.editform.liftModel,
          liftNum: this.editform.liftNum,
          createUnit: this.editform.createUnit,
          createDate: this.editform.createDate,
          // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
          createStandard: this.editform.createStandard,
          updateUnit: this.editform.updateUnit,
          updateDate: this.editform.updateDate,
          // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
          maintenance: this.editform.maintenance,
          superviseDate: this.editform.superviseDate,
          // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
          superviseType: this.editform.superviseType,
          organ: this.editform.organ,
          erpNum: this.editform.erpNum,
          safety: this.editform.safety,
          safetyNum: this.editform.safetyNum,
          majorUnit: this.editform.majorUnit,
          buildUnit: this.editform.buildUnit,
          majorDate: this.editform.majorDate,
          // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
          nextDate: this.editform.nextDate,
          // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
          nextTestDate: this.editform.nextTestDate,
          // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
          lifeCode: this.editform.lifeCode,
          lifeRegistCode: this.editform.lifeRegistCode,
          lifeKind: this.editform.lifeKind,
          electricModel: this.editform.electricModel,
          bridgeBoxWidth: this.editform.bridgeBoxWidth,
          bridgeBoxDeep: this.editform.bridgeBoxDeep,
          bridgeBoxHigth: this.editform.bridgeBoxHigth,
          pressure: this.editform.pressure,
          speed: this.editform.speed,
          speedUp: this.editform.speedUp,
          speedDown: this.editform.speedDown,
          hcNum: this.editform.hcNum,
          maxPressure: this.editform.maxPressure,
          upStation: this.editform.upStation,
          downStation: this.editform.downStation,
          baseStation: this.editform.baseStation,
          hangType: this.editform.hangType,
          hangNum: this.editform.hangNum,
          flameProof: this.editform.flameProof,
          material: this.editform.material,
          materialSign: this.editform.materialSign,
          testedNum: this.editform.testedNum,
          bufferForm: this.editform.bufferForm,
          safetyGear: this.editform.safetyGear,
          drag: this.editform.drag,
          brakeForm: this.editform.brakeForm,
          hang: this.editform.hang,
          jacking: this.editform.jacking,
          openForm: this.editform.openForm,
          maxWeight: this.editform.maxWeight,
          nominalSpeed: this.editform.nominalSpeed,
          nominalWidth: this.editform.nominalWidth,
          tilt: this.editform.tilt,
          conveying: this.editform.conveying,
          liftingHeight: this.editform.liftingHeight,
          section: this.editform.section,
          controller: this.editform.controller,
          driving: this.editform.driving,
          computer: this.editform.computer,
          assign: this.editform.assign,
          storey: this.editform.storey,
          stand: this.editform.stand,
          door: this.editform.door,
          doorPosition: this.editform.doorPosition,
          testType: this.editform.testType,
          specialType: this.editform.specialType,
          superviseCode: this.editform.superviseCode,
          lifeArea: this.editform.lifeArea,
          propertyName: this.editform.propertyName,
          branchName: this.editform.branchName,
          driveModel: this.editform.driveModel,
          driveCode: this.editform.driveCode,
          controlBoxModel: this.editform.controlBoxModel,
          controlBoxCode: this.editform.controlBoxCode,
          carModel: this.editform.carModel,
          carCode: this.editform.carCode,
          counterweightModel: this.editform.counterweightModel,
          counterweightModelCode: this.editform.counterweightModelCode,
          unitArea: this.editform.unitArea,
          branchArea: this.editform.branchArea,
          propertyArea: this.editform.propertyArea,
          proof: this.editform.proof,
          preDate: this.editform.preDate,
          // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
          preDateType: this.editform.preDateType,
          updateDateType: this.editform.updateDateType,
          nextDateType: this.editform.nextDateType,
          createDateType: this.editform.createDateType,
          superviseDateType: this.editform.superviseDateType,
          majorDateType: this.editform.majorDateType,
          nextTestDateType: this.editform.nextTestDateType,
          detailArea: this.editform.detailArea
        };
      } else {
        device = {
          liftId: this.editform.liftId,
          areaId: this.editform.areaId,
          // dateType: this.editform.dateType,
          unit: this.editform.unit,
          unitCode: this.editform.unitCode,
          loginNum: this.editform.loginNum,
          unitNum: this.editform.unitNum,
          liftType: this.editform.liftType,
          liftModel: this.editform.liftModel,
          liftNum: this.editform.liftNum,
          createUnit: this.editform.createUnit,
          createDate: this.editform.createDate,
          createStandard: this.editform.createStandard,
          updateUnit: this.editform.updateUnit,
          // updateDate: this.editform.updateDate,
          maintenance: this.editform.maintenance,
          superviseDate: this.editform.superviseDate,
          superviseType: this.editform.superviseType,
          organ: this.editform.organ,
          erpNum: this.editform.erpNum,
          safety: this.editform.safety,
          safetyNum: this.editform.safetyNum,
          majorUnit: this.editform.majorUnit,
          buildUnit: this.editform.buildUnit,
          majorDate: this.editform.majorDate,
          nextDate: this.editform.nextDate,
          nextTestDate: this.editform.nextTestDate,
          lifeCode: this.editform.lifeCode,
          lifeRegistCode: this.editform.lifeRegistCode,
          lifeKind: this.editform.lifeKind,
          electricModel: this.editform.electricModel,
          bridgeBoxWidth: this.editform.bridgeBoxWidth,
          bridgeBoxDeep: this.editform.bridgeBoxDeep,
          bridgeBoxHigth: this.editform.bridgeBoxHigth,
          pressure: this.editform.pressure,
          speed: this.editform.speed,
          speedUp: this.editform.speedUp,
          speedDown: this.editform.speedDown,
          hcNum: this.editform.hcNum,
          maxPressure: this.editform.maxPressure,
          upStation: this.editform.upStation,
          downStation: this.editform.downStation,
          baseStation: this.editform.baseStation,
          hangType: this.editform.hangType,
          hangNum: this.editform.hangNum,
          flameProof: this.editform.flameProof,
          material: this.editform.material,
          materialSign: this.editform.materialSign,
          testedNum: this.editform.testedNum,
          bufferForm: this.editform.bufferForm,
          safetyGear: this.editform.safetyGear,
          drag: this.editform.drag,
          brakeForm: this.editform.brakeForm,
          hang: this.editform.hang,
          jacking: this.editform.jacking,
          openForm: this.editform.openForm,
          maxWeight: this.editform.maxWeight,
          nominalSpeed: this.editform.nominalSpeed,
          nominalWidth: this.editform.nominalWidth,
          tilt: this.editform.tilt,
          conveying: this.editform.conveying,
          liftingHeight: this.editform.liftingHeight,
          section: this.editform.section,
          controller: this.editform.controller,
          driving: this.editform.driving,
          computer: this.editform.computer,
          assign: this.editform.assign,
          storey: this.editform.storey,
          stand: this.editform.stand,
          door: this.editform.door,
          doorPosition: this.editform.doorPosition,
          testType: this.editform.testType,
          specialType: this.editform.specialType,
          superviseCode: this.editform.superviseCode,
          lifeArea: this.editform.lifeArea,
          propertyName: this.editform.propertyName,
          branchName: this.editform.branchName,
          driveModel: this.editform.driveModel,
          driveCode: this.editform.driveCode,
          controlBoxModel: this.editform.controlBoxModel,
          controlBoxCode: this.editform.controlBoxCode,
          carModel: this.editform.carModel,
          carCode: this.editform.carCode,
          counterweightModel: this.editform.counterweightModel,
          counterweightModelCode: this.editform.counterweightModelCode,
          unitArea: this.editform.unitArea,
          branchArea: this.editform.branchArea,
          propertyArea: this.editform.propertyArea,
          proof: this.editform.proof,
          preDate: this.editform.preDate,
          // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
          // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
          // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
          // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
          // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
          // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
          // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
          preDateType: this.editform.preDateType,
          updateDateType: this.editform.updateDateType,
          nextDateType: this.editform.nextDateType,
          createDateType: this.editform.createDateType,
          superviseDateType: this.editform.superviseDateType,
          majorDateType: this.editform.majorDateType,
          nextTestDateType: this.editform.nextTestDateType,
          detailArea: this.editform.detailArea
        };
      }
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log(device)
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return;
        }
        request.post('/Device/update', device).then(res => {
          this.count = 0;
          if (res.code === "0") {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.load(1);
            this.dialogFormVisibleEdit = false;
          } else {
            this.$message({
              message: "编辑失败",
              type: "error"
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));
      // this.editform.createDate=this.dateShow(this.editform.createDateType, this.editform.createDate);
      // this.editform.updateDate=this.dateShow(this.editform.updateDateType, this.editform.updateDate);
      // this.editform.superviseDate=this.dateShow(this.editform.superviseDateType, this.editform.superviseDate);
      // this.editform.majorDate=this.dateShow(this.editform.majorDateType, this.editform.majorDate);
      // this.editform.nextDate=this.dateShow(this.editform.nextDateType, this.editform.nextDate);
      // this.editform.nextTestDate=this.dateShow(this.editform.nextTestDateType, this.editform.nextTestDate);
      // this.editform.preDate=this.dateShow(this.editform.preDateType, this.editform.preDate);
      this.getEqpType(this.editform.specialType);
      this.getliftType(this.editform.lifeKind, 1);
      // this.repeatName = row.templateName;
      console.log(this.editform + "---" + this.editform.areaId);
      request.post('/Device/ParentArea', this.editform.areaId).then(res => {
        console.log(res.data);
        this.areaList = res.data.deviceAreas1;
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].areaId === res.data.areaId1) {
            this.areaParentIdOne = i;
          }
        }
        this.areaList2 = res.data.deviceAreas2;
        for (let i = 0; i < this.areaList2.length; i++) {
          if (this.areaList2[i].areaId === res.data.areaId2) {
            this.areaParentIdTwo = i;
          }
        }
        this.areaList3 = res.data.deviceAreas3;
        for (let i = 0; i < this.areaList3.length; i++) {
          if (this.areaList3[i].areaId === res.data.areaId3) {
            this.areaParentIdThree = i;
          }
          // if (this.areaList3[i].areaId === res.data.areaId3) {
          //   this.areaParentIdThree = i;
          // }
        }
        // this.areaList4 = res.data.deviceAreas4;
        // for (let i = 0; i < this.areaList4.length; i++) {
        //   if (this.areaList4[i].areaId === res.data.areaId4) {
        //     this.areaParentIdFour = i;
        //   }
        // }
        // this.areaList5 = res.data.deviceAreas5;
        // for (let i = 0; i < this.areaList5.length; i++) {
        //   if (this.areaList5[i].areaId === this.editform.areaId) {
        //     this.areaParentIdFive = i;
        //   }
        // }
      });
    },

    //删除按钮点击事件
    deleteOne(liftId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/Device/delete', liftId).then(res => {
          if (res.code === "0") {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '已创建工单不能删除！'
            });
          }
          this.load(1);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    queryAreaList(parentId) {
      request.post('/Device/selectArea', parentId).then(res => {
        console.log(res.data);
        this.areaList = res.data;
        this.areaList2 = [];
        this.areaList3 = [];
        // this.areaList4 = [];
        // this.areaList5 = [];
        this.areaParentIdTwo = '';
        this.areaParentIdThree = '';
        // this.areaParentIdFour = '';
        // this.areaParentIdFive = '';
      });
    },

    queryAreaList2() {
      if (this.areaParentIdOne === '') {
        this.$message({
          message: "请完成第一个选择",
          type: "warning"
        });
        this.areaParentIdTwo = '';
        this.areaList2 = [];
        this.areaParentIdThree = '';
        this.areaList3 = [];
        // this.areaParentIdFour = '';
        // this.areaList4 = [];
      } else {
        request.post('/Device/selectArea', this.areaList[this.areaParentIdOne].areaId).then(res => {
          console.log(res);
          if (res.code === "0") {
            this.areaList2 = res.data;
          } else this.areaList2 = [];
          this.areaParentIdTwo = '';
          this.areaList3 = [];
          this.areaParentIdThree = '';
          // this.areaParentIdFour = '';
          // this.areaList4 = [];
        });
      }
      // this.queryAreaList(this.areaList[this.areaParentIdOne].areaId);
    },

    queryAreaList3() {
      // console.log(this.areaParentIdTwo+"---areaId");
      if (this.areaParentIdTwo === '') {
        this.$message({
          message: "请完成第二个选择",
          type: "warning"
        });
        this.areaParentIdThree = '';
        this.areaList3 = [];
      } else {
        request.post('/Device/selectArea', this.areaList2[this.areaParentIdTwo].areaId).then(res => {
          console.log(res);
          if (res.code === "0") {
            this.areaList3 = res.data;
          } else this.areaList3 = [];
          this.areaParentIdThree = '';
          // this.areaParentIdFour = '';
          // this.areaList4 = [];
        });
      }
    },

    // queryAreaList4() {
    //   // console.log(this.areaParentIdTwo+"---areaId");
    //   if (this.areaParentIdThree === '') {
    //     this.$message({
    //       message: "请完成第三个选择",
    //       type: "warning"
    //     });
    //     this.areaParentIdFour = '';
    //     this.areaList4 = [];
    //   } else {
    //     request.post('/Device/selectArea', this.areaList3[this.areaParentIdThree].areaId).then(res => {
    //       console.log(res);
    //       if (res.code === "0") {
    //         this.areaList4 = res.data;
    //       } else this.areaList4 = [];
    //       this.areaParentIdFour = '';
    //     });
    //   }
    // },
    // queryAreaList5() {
    //   console.log(this.areaParentIdFour + "---areaId");
    //   if (this.areaParentIdFour === '') {
    //     this.$message({
    //       message: "请完成第四个选择",
    //       type: "warning"
    //     });
    //     this.areaParentIdFive = '';
    //     this.areaList5 = [];
    //   } else {
    //     request.post('/Device/selectArea', this.areaList4[this.areaParentIdFour].areaId).then(res => {
    //       console.log(res);
    //       if (res.code === "0") {
    //         this.areaList5 = res.data;
    //       } else this.areaList5 = [];
    //       this.areaParentIdFive = '';
    //     });
    //   }
    // },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      if (this.varValue !== this.search) {
        this.search = this.varValue;
      }
      if (this.varValue1 !== this.superviseCode) {
        this.superviseCode = this.varValue1;
      }
      this.load(1);
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      if (this.varValue !== this.search) {
        this.search = this.varValue;
      }
      if (this.varValue1 !== this.superviseCode) {
        this.superviseCode = this.varValue1;
      }
      this.load(1);
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].solution_Lock === "锁定") {
          if (rowIndex === i) {
            return 'warning-row';
          }
        } else {
          if (rowIndex === i) {
            return 'success-row';
          }
        }
      }
      return '';
    }
  }
};